'use strict';

var novicell = novicell || {};
novicell.anchorLinks =
    novicell.anchorLinks ||
    (function() {
        function init() {
            if (location.hash) {
                var findId = location.hash.substring(1);
                var node = document.getElementById(findId);
                scrollToElement(node);
            }
            var body = document.querySelector('body');
            body.addEventListener('click', function(e) {
                if (e.path != undefined) {
                    for (var i = 0; i < e.path.length; i++) {
                        if (
                            e.path[i].tagName != undefined &&
                            e.path[i].tagName.toLowerCase() == 'a' &&
                            e.path[i].getAttribute('href').indexOf('#') != -1
                        ) {
                            var targetId = e.path[i]
                                .getAttribute('href')
                                .split('#')[1];
                            var node = document.getElementById(targetId);
                            if (node != null) {
                                e.preventDefault();
                                scrollToElement(node);
                                window.location.hash = targetId;
                            }
                            break;
                        }
                    }
                }
            });
        }

        function scrollToElement(node) {
            setTimeout(function() {
                var siteheader = document.querySelector('.o-siteheader');
                var yourHeight = siteheader.offsetHeight;

                // scroll to your element
                node.scrollIntoView(true);

                // now account for fixed header
                var scrolledY = window.scrollY;

                if (scrolledY) {
                    window.scroll(0, scrolledY - yourHeight);
                }
            }, 1);
        }

        return {
            init: init
        };
    })();
